import React, { Suspense, useState, useEffect, useCallback } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import NavigationStore from 'shared/navigation/NavigationStore';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider as ReduxProvider } from 'react-redux';
//import { ApolloProvider } from '@apollo/react-hooks'

import { useUser } from 'shared/auth';
import LoggingIn from 'shared/auth/ui/LoggingIn';

import { Content } from '../Drawer';
import { AuthProvider } from '../../auth/ui';
import store from '../../store';
import { AppRoot } from './styled';
import theme from './theme';
import { ApolloAndUserProvider } from '../../apollo';
import ServerNotice from '../../components/ServerNotice';
import GhostingNoticeBar from '../../components/GhostingNoticeBar';
import Idle from './Idle';
import { ErrorBoundary } from 'react-error-boundary';

import '../../design-system/style.scss';
import { RenderErrorBoundary } from 'npo/ErrorBoundary';

const noDrawerStates = ['signIn', 'forgotPassword'];

function Body({ children, authState, ...props }) {
  const [inReportWizard, setInReportWizard] = useState();
  const handleHashChange = useCallback(
    event => {
      setInReportWizard(/^(\#\/report-wizard\/)/.test(event.detail));
    },
    [setInReportWizard],
  );
  useEffect(() => {
    window.addEventListener('trueimpact.hashchange', handleHashChange);
    return () => {
      window.removeEventListener('trueimpact.hashchange', handleHashChange);
    };
  }, [handleHashChange]);
  const user = useUser();
  const show =
    !inReportWizard &&
    !noDrawerStates.includes(authState) &&
    user &&
    (user.role === 'funder' || user.role === 'superAdmin') &&
    !window.location.pathname.startsWith('/donor');
  //    && (user.role === 'funder' || (user.npoPortal && user.role === 'grantee'))

  return (
    <>
      <Idle />
      <Content noMargin {...props}>
        {children}
      </Content>
    </>
  );
}

function Loading() {
  return <LoggingIn>Loading ...</LoggingIn>;
}

window._pushUrl = url => {
  const event = new CustomEvent('pushurl', {
    detail: url,
  });
  alert(url);

  window.dispatchEvent(event);
};

export default function AppShell({ children }) {
  const { pathname } = window.location;
  const [hasError, setHasError] = useState(false);
  return (
    <BrowserRouter>
      <ApolloAndUserProvider>
        <ThemeProvider theme={theme}>
          <AppRoot unsetAll={pathname.startsWith('/report')}>
            <CssBaseline />
            <ServerNotice />
            <GhostingNoticeBar />
            <ErrorBoundary
              FallbackComponent={ErrorFallback}
              onReset={() => setHasError(false)}
              resetKeys={[hasError]}
            >
              <ReduxProvider store={store}>
                <NavigationStore>
                  <Suspense fallback={<Loading />}>
                    <AuthProvider>
                      <Body>{children}</Body>
                    </AuthProvider>
                  </Suspense>
                </NavigationStore>
              </ReduxProvider>
            </ErrorBoundary>
          </AppRoot>
        </ThemeProvider>
      </ApolloAndUserProvider>
    </BrowserRouter>
  );
}

function ErrorFallback({ error, resetErrorBoundary }) {
  // return (
  //   <div role="alert">
  //     <p>Something went wrong:</p>
  //     <pre>{error.message}</pre>
  //     <button onClick={resetErrorBoundary}>Try again</button>
  //   </div>
  // );

  return <RenderErrorBoundary message={error.message} />;
}
